export default __webpack_public_path__ + "static/media/900.81645cf9.png";